import { render, staticRenderFns } from "./ResumenTransac.vue?vue&type=template&id=1a022dd3&scoped=true"
import script from "./ResumenTransac.vue?vue&type=script&lang=js"
export * from "./ResumenTransac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a022dd3",
  null
  
)

export default component.exports